import Component from "../../../core/Component.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";
import {sendMoveMobileSignInPage} from "../../../bridge/renewal-signup/index.js";
import {isWebView} from "../store.js";


export class Header extends Component {

    template() {
        const {isShowLoginBtn = false, isShowPrevBtn = false} = this.$props;

        return `
                  ${isShowPrevBtn ? this.getPrevBtnTemplate() : ''}
                   ${isShowLoginBtn ? this.getLoginBtnTemplate() : ''}
                `
    }

    getPrevBtnTemplate() {
        return `
            <div class="prev-button-wrap" style="">
                    <button id="prevBtn"><i class="sign-icons-left-2"></i></button>
                </div>
        `
    }

    getLoginBtnTemplate() {
        return `
            <div class="login-button-wrap">
                    <span>${i18next.t(login.alreadyAccount)}</span>
                    <button id="moveSignInBtn">${i18next.t(dictionary.login)}</button>
                </div>
        `
    }

    setEvent() {
        this.addClickEventOfLoginBtn();
        this.addClickEventOfPrevBtn();
    }
    addClickEventOfPrevBtn() {
        const {isShowPrevBtn = false} = this.$props;
        if(!isShowPrevBtn) {
            return;
        }
        this.addEvent("click", "#prevBtn", () => {
            history.back();
        })
    }

    addClickEventOfLoginBtn() {
        const {isShowLoginBtn = false} = this.$props;
        if(!isShowLoginBtn) {
            return;
        }
        this.addEvent("click", "#moveSignInBtn", () => {
            if(isWebView()) {
                sendMoveMobileSignInPage();
                return;
            }
            SignUpViewChanger.moveSignInPage();
        })
    }

}